import React, { useState, useEffect } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Link } from "react-router-dom";
import { Box, Grid, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import RemarksForm from "../RemarksForm";
import DragAndDropTable from "../../../common/DragAndDropTable";

function orderData(data) {
  let len = data.length;
  let swapped;
  do {
    swapped = false;
    for (var i = 0; i < len - 1; i++) {
      if (data[i].seq > data[i + 1].seq) {
        let temp = data[i];
        data[i] = data[i + 1];
        data[i + 1] = temp;
        swapped = true;
      }
    }
  } while (swapped);
  return data;
}

function formatDataToRows(content) {
  const formattedData = [];
  for (var i = 0; i < content.length; i++) {
    formattedData.push({
      ...content[i],
      en: content[i].localizations.en.content,
      tc: content[i].localizations.tc.content,
      seq: content[i].sequence,
    });
  }
  return formattedData;
}

export function formatRowToData(data, seq, image) {
  var formattedData = {
    code: data.code ? data.code : 0,
    url: data.url,
    image: image ? image : data.image ? data.image : null,
    localizations: {
      en: {
        content: data.en,
      },
      tc: {
        content: data.tc,
      },
    },
    type: data.type,
    seq: seq !== null ? seq : data.seq,
  };
  if (seq || seq === 0) formattedData.seq = seq;
  return formattedData;
}

export default function RemarksListingPage({ match, disabled, ...props }) {
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await apiHelper.cinefan.getAllRemarks();
      const formattedData = formatDataToRows(response.data.content);
      const orderedData = orderData(formattedData);
      setRows(orderedData);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const minSeq = () => {
    return rows[0] ? rows[0].seq - 1 : 0;
  };

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const saveOrdering = async () => {
    try {
      const requestArg = [];
      for (var i = 0; i < rows.length; i++) {
        const request = apiHelper.cinefan.updateRemarkById(
          rows[i].id,
          formatRowToData(rows[i], i)
        );
        requestArg.push(request);
      }
      await Promise.all(requestArg);
      toast.dark("Your changes is saved.");
      await fetchData();
    } catch (err) {
      console.log(err);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Image",
        accessor: "image",
        Cell: ({ row }) => {
          return (
            <img
              src={row.original.image}
              alt={row.original.code}
              style={{ maxHeight: "30px", maxWidth: "30px" }}
            />
          );
        },
        disableGlobalFilter: true,
      },
      {
        Header: "Name (English)",
        accessor: "en",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/edit/${row.original.id}`}
            >
              {row.original.en}
            </Link>
          );
        },
      },
      {
        Header: "Name (Traditional Chinese)",
        accessor: "tc",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/edit/${row.original.id}`}
            >
              {row.original.tc}
            </Link>
          );
        },
      },
      {
        Header: "Type",
        accessor: "type",
        disableGlobalFilter: true,
      },
    ],
    []
  );

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Remarks
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <RemarksForm
            description="Add New Remark"
            submitBtnTxt="Add New Remark"
            gridSize={4}
            formatRowToData={formatRowToData}
            fetchData={fetchData}
            minSeq={minSeq}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={8}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={fetchData}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={(ids) => apiHelper.cinefan.bulkDeleteRemarks(ids)}
            subject="remark"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </>
  );
}
